var _rect, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _circle, _path8, _ellipse, _path9, _ellipse2, _path10, _ellipse3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _feBlend, _mask, _g4, _path20, _path21, _path22, _path23, _g5, _path24, _g6, _path25, _path26, _path27, _path28, _path29, _path30, _g7, _path31, _path32, _g8, _circle2, _path33, _circle3, _circle4, _circle5, _path34, _circle6, _circle7, _g9, _circle8, _path35, _g10, _g11, _g12, _g13, _polygon, _polygon2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _circle9, _circle10, _g14, _g15, _path47, _path48, _path49, _path50, _path51, _path52, _g16, _g17, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g18, _path61, _g19, _path62, _path63, _ellipse4, _path64, _path65, _ellipse5, _path66, _path67, _ellipse6, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _circle11, _polygon3, _polygon4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIlluCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    enableBackground: "new 0 0 2000 2000",
    xmlSpace: "preserve"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    y: -0.3,
    fill: "none",
    width: 2000,
    height: 2000
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15747.9658,
    y1: 1355.1096,
    x2: 16909.1406,
    y2: 1355.1096,
    gradientTransform: "matrix(-1 0 0 1 16970.3594 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2765,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4539,
    style: {
      stopColor: "#11423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#0E2A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M1217.8,1442.9l-737.3-425.6c-2.8-1.6-6.3-1.6-9.2,0L65.8,1251.5c-6.1,3.5-6.1,12.3,0,15.9 L803,1693c2.8,1.6,6.3,1.6,9.2,0l405.7-234.3C1223.9,1455.2,1223.9,1446.4,1217.8,1442.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 15748.0596,
    y1: 1480.9469,
    x2: 16909.0469,
    y2: 1480.9469,
    gradientTransform: "matrix(-1 0 0 1 16970.3594 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M1222.3,1464.5c-0.1,3.2-2.3,6.4-6.5,8.8L823.3,1700c-8.7,5-22.8,5-31.5,0l-724-418 c-4.4-2.6-6.6-5.9-6.5-9.3l0-14.5c-0.2,3.5,1.9,7,6.5,9.6l724,418c8.7,5,22.8,5,31.5,0l392.5-226.7c4.3-2.5,6.5-5.8,6.5-9.1 L1222.3,1464.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    points: "570.8,1383.7 579.9,1388.9 622.6,1364.2 613.5,1359  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 426,
    y1: 1473.4,
    x2: 850,
    y2: 1228.6
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "622.6,1383.7 613.5,1388.9 570.8,1364.2 579.9,1359  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 975,
    y1: 1591.7,
    x2: 286.7,
    y2: 1194.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 948.1,
    y1: 1413.7,
    x2: 360.4,
    y2: 1074.4
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 948.1,
    y1: 1413.7,
    x2: 360.4,
    y2: 1074.4
  })), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 635.5,
    y1: 1594.4,
    x2: 1021.7,
    y2: 1371.4
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 145.6,
    y1: 1311.2,
    x2: 541.1,
    y2: 1082.9
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 710.2,
    y1: 1637.5,
    x2: 1133.5,
    y2: 1392.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "738.8,1454.9 748,1449.7 790.7,1474.3 781.5,1479.5  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1188.5,
    y1: 1468.4,
    x2: 790.7,
    y2: 1238.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "790.7,1323 813.9,1309.8 922.2,1372.3 899,1385.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    points: "478,1142.9 468.9,1148.1 426.2,1123.4 435.3,1118.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "426.2,1274.7 403,1288 294.6,1225.4 317.8,1212.2  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.9094,
    y1: 1472.6395,
    x2: 1690.0853,
    y2: 1472.6395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2765,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4539,
    style: {
      stopColor: "#11423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#0E2A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M533.5,1560.4l737.3-425.6c2.8-1.6,6.3-1.6,9.2,0l405.6,234.3c6.1,3.5,6.1,12.3,0,15.9 l-737.2,425.6c-2.8,1.6-6.3,1.6-9.2,0l-405.7-234.3C527.4,1572.7,527.4,1563.9,533.5,1560.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 529.0032,
    y1: 1598.4768,
    x2: 1689.9906,
    y2: 1598.4768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M529,1582.1c0.1,3.2,2.3,6.4,6.5,8.8L928,1817.5c8.7,5,22.8,5,31.5,0l724-418 c4.4-2.6,6.6-5.9,6.5-9.3l0-14.5c0.2,3.5-1.9,7-6.5,9.6l-724,418c-8.7,5-22.8,5-31.5,0l-392.5-226.7c-4.3-2.5-6.5-5.8-6.5-9.1 L529,1582.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1322.5,
    y1: 1593.9,
    x2: 898.5,
    y2: 1349.1
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1125.9,1504.2 1135,1509.4 1177.7,1484.7 1168.6,1479.5  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 773.5,
    y1: 1712.2,
    x2: 1461.8,
    y2: 1314.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 800.4,
    y1: 1534.2,
    x2: 1388.1,
    y2: 1194.9
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 800.4,
    y1: 1534.2,
    x2: 1388.1,
    y2: 1194.9
  })), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1113,
    y1: 1714.8,
    x2: 726.8,
    y2: 1491.9
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1602.9,
    y1: 1431.7,
    x2: 1207.4,
    y2: 1203.4
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1038.3,
    y1: 1758,
    x2: 615,
    y2: 1512.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1009.7,1575.4 1000.5,1570.2 957.8,1594.8 967,1600  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 560,
    y1: 1588.9,
    x2: 957.8,
    y2: 1359.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "957.8,1443.5 934.6,1430.3 826.3,1492.8 849.5,1506.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    points: "1270.5,1263.4 1279.6,1268.6 1322.3,1243.9 1313.2,1238.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1322.3,1395.2 1345.5,1408.5 1453.9,1345.9 1430.7,1332.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 15031.6846,
    y1: 1071.8903,
    x2: 16192.8604,
    y2: 1071.8903,
    gradientTransform: "matrix(-1 0 0 1 16970.3594 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2765,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4539,
    style: {
      stopColor: "#11423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#0E2A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M1934.1,1159.6L1196.8,734c-2.8-1.6-6.3-1.6-9.2,0L782.1,968.3c-6.1,3.5-6.1,12.3,0,15.9 l737.2,425.6c2.8,1.6,6.3,1.6,9.2,0l405.7-234.3C1940.2,1172,1940.2,1163.2,1934.1,1159.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 15031.7783,
    y1: 1197.7275,
    x2: 16192.7656,
    y2: 1197.7275,
    gradientTransform: "matrix(-1 0 0 1 16970.3594 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M1938.6,1181.3c-0.1,3.2-2.3,6.4-6.5,8.8l-392.5,226.7c-8.7,5-22.8,5-31.5,0l-724-418 c-4.4-2.6-6.6-5.9-6.5-9.3l0-14.5c-0.2,3.5,1.9,7,6.5,9.6l724,418c8.7,5,22.8,5,31.5,0l392.5-226.7c4.3-2.5,6.5-5.8,6.5-9.1 L1938.6,1181.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    points: "1293.4,1103.4 1302.6,1108.6 1345.3,1083.9 1336.1,1078.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1148.6,
    y1: 1193.1,
    x2: 1572.6,
    y2: 948.3
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1345.3,1103.4 1336.1,1108.6 1293.4,1083.9 1302.6,1078.7  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1697.6,
    y1: 1311.4,
    x2: 1009.4,
    y2: 914
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1670.8,
    y1: 1133.4,
    x2: 1083,
    y2: 794.1
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1670.8,
    y1: 1133.4,
    x2: 1083,
    y2: 794.1
  })), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1358.1,
    y1: 1314,
    x2: 1744.3,
    y2: 1091.1
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 868.2,
    y1: 1030.9,
    x2: 1263.7,
    y2: 802.6
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1432.8,
    y1: 1357.2,
    x2: 1856.1,
    y2: 1111.9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1461.4,1174.6 1470.6,1169.4 1513.3,1194 1504.1,1199.2  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1911.1,
    y1: 1188.1,
    x2: 1513.3,
    y2: 958.4
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1513.3,1042.7 1536.5,1029.5 1644.8,1092 1621.6,1105.3  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1523.1907,
    y1: 595.3574,
    x2: 1579.2548,
    y2: 595.3574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M1579.3,1122.6L1579.3,1122.6c-17,11.3-39.1,11.3-56.1,0v0l10.2-669.7l15.5-393.4h4.7l15.5,395.1 L1579.3,1122.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1447.5377,
    y1: 383.8246,
    x2: 1654.9077,
    y2: 383.8246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_8_)",
    cx: 1551.2,
    cy: 383.8,
    r: 103.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1518.8862,
    y1: 242.73,
    x2: 1583.5592,
    y2: 242.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M1583.6,286L1583.6,286c-20.5,9.5-44.2,9.5-64.7,0h0v-93.7l0,0c20.5,9.5,44.2,9.5,64.7,0v0V286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1524.2158,
    y1: 521.335,
    x2: 1578.2296,
    y2: 521.335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_10_)",
    cx: 1551.2,
    cy: 521.3,
    rx: 27,
    ry: 9.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1524.2158,
    y1: 528.7783,
    x2: 1578.2296,
    y2: 528.7783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M1524.2,526.7c0,5.2,12.1,9.5,27,9.5c14.9,0,27-4.3,27-9.5v-5.4c0,5.2-12.1,9.5-27,9.5 c-14.9,0-27-4.3-27-9.5V526.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1524.2158,
    y1: 513.2377,
    x2: 1578.2296,
    y2: 513.2377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_12_)",
    cx: 1551.2,
    cy: 513.2,
    rx: 27,
    ry: 9.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1524.2158,
    y1: 520.681,
    x2: 1578.2296,
    y2: 520.681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M1524.2,518.6c0,5.2,12.1,9.5,27,9.5c14.9,0,27-4.3,27-9.5v-5.4c0,5.2-12.1,9.5-27,9.5 c-14.9,0-27-4.3-27-9.5V518.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1518.8862,
    y1: 192.2302,
    x2: 1583.5592,
    y2: 192.2302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_14_)",
    cx: 1551.2,
    cy: 192.2,
    rx: 32.3,
    ry: 11.4
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1543.7859,
    y1: 125.392,
    x2: 1558.6595,
    y2: 125.392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M1543.8,188.9l5.1-129.3h4.7l5.1,129.6l0,0c-4.5,2.8-10.3,2.7-14.7-0.2L1543.8,188.9z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43FFBB",
    strokeMiterlimit: 10,
    d: "M1451.1,411.5L1451.1,411.5c62.4,34,137.8,34,200.1,0l0,0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43FFBB",
    strokeMiterlimit: 10,
    d: "M1448.4,398.4L1448.4,398.4c64.1,35,141.6,35,205.7,0l0,0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1557.6,166.8l-0.1-1.2c-3.8,2-8.8,2-12.7,0l0,0l0,1.2c2,1,4.2,1.5,6.4,1.5 C1553.4,168.3,1555.6,167.8,1557.6,166.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1557.2,156.4l0-1.2c-3.7,1.8-8.1,1.8-11.8,0l0,1.2c1.9,0.9,3.9,1.3,6,1.3 C1553.3,157.7,1555.3,157.3,1557.2,156.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1556.2,130.4l0-1.2c-3.1,1.2-6.7,1.2-9.8,0l0,1.2c1.6,0.6,3.3,0.9,4.9,0.9S1554.6,131,1556.2,130.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1555.8,120.1l0-1.1c-2.9,1-6.1,1-9,0l0,1.1c1.5,0.5,3,0.8,4.5,0.8 C1552.8,120.8,1554.3,120.5,1555.8,120.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1554.8,94.9l0-1.1c-2.3,0.6-4.7,0.6-7,0l0,1.1c1.2,0.3,2.4,0.5,3.5,0.5 C1552.4,95.4,1553.6,95.2,1554.8,94.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1554.3,83.5l0-1.1c-2,0.5-4.1,0.5-6.1,0l0,1.1c1,0.2,2.1,0.3,3.1,0.3 C1552.3,83.9,1553.3,83.8,1554.3,83.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 1256.6,
    y: 1110.4,
    width: 330.2,
    height: 190.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1256.6,
    y: 1110.4,
    width: 330.2,
    height: 190.7,
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 335,
    height: 196,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAOqAAAHfwAACPv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAMQBTwMBIgACEQEDEQH/ xAB9AAEAAgMBAQAAAAAAAAAAAAAABAUBAwYCBwEBAAAAAAAAAAAAAAAAAAAAABAAAgMBAQACAgID AQAAAAAAAQQAAgMFEUAhIDBQEhCAMUERAAMBAQADAQEBAAAAAAAAAAABITERMEACIFAQEgEAAAAA AAAAAAAAAAAAAACA/9oADAMBAAIRAxEAAAD5+AAAAAAAAZMZk2ZU46PBzGLutIzOAAAAAAAAAAAA AAAA2WRAtLS1K2xs5hUrwczXdhDODrO9qTklpXHgAAAAAAAAAAABmSR51lclZcWFiQrCXJI+/d6N TaI8ew8lLX9JGOPp+6rT5/C7ilKBJjAAAAAAAAA9njdNuitubC0IVlLmEeVu9nn1kAAAY8bMEaJa aygq+rhnFUvf1ZwOrq6YrXryAAAAAM7rQg3E63IVrLsCNN3bzXszkxkAAAAAGMjzq34IEK60nM1P Y15w1P3tOchi4rDUAAezEz1Zmbbxamyz8WJmTn2MgAAAAAAAAAxkaos7WUtX0VaczU9RVHMRL6uI D34G7Tks7KhsTobXnrYv7Clsiz9R9x6YyAAAAAAAAADA85jmquk1hFq5NSaK3ZXmNQAPfgWdvysg 7m24a5Oxm8vZl57rpRIecmQAAAAAAGPJ68aohvhRqwlVUSmJlRG0HvwAAAAGZsEdPccJYnf2HE25 1knnbAtsxJBsYGQAAGAx4jG+LGryZXQKgsaetryVEwAAAAAAAAN9pSZO0tvn9wd1P461Om3Uk0sU bcbHkZa9Ru0RoRLgQaosKitqSfWagAAAAAAAAAAA9eRYXPLbDvLPgrg7OVys86BT4LOLXQCxrKyo LKnieDOAAAAAAAAAAAAAAAb9AurPk5B1zmxc1dfoNukAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP//a AAgBAgABBQD/AER//9oACAEDAAEFAP8ARH//2gAIAQEAAQUA+HWlrSqtzLLXEtU1P8IAScEr3OHO lUPq6H0xzvZsnfMkEfwWKumhV5kX53kxQlUvqyU2QjPO9jXMmq2mZ+dnjfQq80mK80CLoATFICZq CBWFUTRQTZL2MIAxrm+xrmkHTK+Z+VSlrlbnWuVOb5FueBMEgJioBM1wJXGDIQ5CWxBmi4M2UBjC IMZ5/sb5nsZ59qG1bVPxgCTgjfQqczyK84CLogTFQCZLASmIEFAJ5/nyWoDL4gzVYGbJgxhEGNc4 GN8ybp6Zkgj4mS2mhU5kV53kXQAmCYEyWAmeIErQCefn5LUBmmIM1WBm6YMZQBjXN9jXMmq+mZ+B nle5V5pJV5vkWQ8i6QExVAmeAErmBAPP1key2YM0wBmyoM3SBjPPBjXNBjXONTfO9D+ytTYro2uV OcItzwIukBMVAJkuBKZAQVA/eagy+QM1XBmygMYSBjXPBjfNEYRvQmpB/R/2YrX0KvPEVQEWSEwU AmSwEzxAlaAfDtQGaYgzZYGMKAxlIRpERpCar3zP5VobFdT0rKCLKiLLCYLiZYgSmYEA8+KR7L5g zXEGbriMrCMqiMqCbq+G1DU/5pT04YiL5CLZCLZiL5iY0EpXz5OlZtQRjMRnMRnIRjITfIS9PDBM rD3Cwi9hFrCLWEXsJiRKn6+Rc/WxEYIjNhGbCMWE3sJpYE/+wEiZb/1K7IizAizAi+4mGwmekFgf j2sBNdBN9hGNxGWBGWBGGRNdjYk+/jTW1Cs95FXhFnBF2xMWQZnsDK3BnvwyfJbQCabgTZkCMNiM uCNOiMu+y+lrn8wSJi3fMqdGK9AGLPAzBsGZMAymwMFgfg2uBL7ATVkCbuARl4CNdARvozZm+h/X W1qlZ+1Cp0gYt0AYu6DMWwZkwDKagwWB/abAS+oE1YAmzYEYeAjXQAjfSjD17m1jY/uz2vmVekRF el7FnwZg6DMWgZnuDK6AwEH9JIEtoBNNwJs0BGHQIy+BGul5GuibG+l7n4WLWmZU6cV6IMXfBmDg MyZBlNgZXQGe/iSBLaATTcCasgTdwCMvgRro+RrpzVjTQ/FBIK718yp0/Yt0QYu8DMWwZkyDKbAw aAz+4n9xLaCX2AmrIE2bAjDwEa6Pkb6c3cvoSSfk00tQrdG1Sr0vYt0AZg6DMmwZRkQMCFgS7M1b Am7wEZ6Hkb6XkY6Frm1rWPzM975lXpERbo+zB/2ZOyrks5NXZu/5Gej5GekTNNr6H5//ACYtXzK3 RmPQlXvq7/1v0Iz0pqzfQ/wYJBybvWVf+rv/AFq1e8JJ/h/v43//2gAIAQICBj8ACP8A/9oACAED AgY/AAj/AP/aAAgBAQEGPwD04v8AeNfxeKlQoYYOEUOP+FnEKChhhhg4PiMnvxCbXWKChhhhhhg4 ODaXDjXt8+UJ/SFBQUMM/OGDg4ODfyjn0uevxUXVBQUFDDPDhg4ODhFC+pnELqFBQwzy4ODg4NpF U9HiQm10UFBQz0MMHBwcG/lcOfS8vEuif0hQUFBQz08MHBwcG0cfiqgoKCgoZ6+Dg4ODhk/cE2hQ UFBT2sHBwcHDqL+kIQvdYxj/AGhCF7rGMf6oqKior7jGOjo6T9QXWKioqb7Ojo6OjSZfBC4Kioqa b6umjo6OmzydT4JfTFRUVNN9HTR0dHTnyzrffPGJN8FRUVN82mjo6OjXy+nfp+nsFRUVNN8ejo6O jSZXPW6oJNwVFRU0396aOjo6Rw6/Z78sS+mKioqaab/mmmjo6NfLOt992OCTYqKmmmmjo6NJ9Ot/ wd6hU0000fGbP4nUU00jOv8Au//Z",
    transform: "matrix(1 0 0 1 1254 1108)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SVGID_16_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#124B46",
    d: "M1260.1,1210.8c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L1260.1,1210.8z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1257.0305,
    y1: 1220.6528,
    x2: 1586.2756,
    y2: 1220.6528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M1257,1189.4c0,2,1.3,4,3.9,5.5l151.3,87.4c5.2,3,13.7,3,18.9,0l151.3-87.3 c2.6-1.5,3.9-3.5,3.9-5.5v-32.7c0,2-1.3,4-3.9,5.5l-151.3,87.3c-5.2,3-13.7,3-18.9,0l-151.3-87.4c-2.6-1.5-3.9-3.5-3.9-5.5V1189.4z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1256.5637,
    y1: 1156.7947,
    x2: 1586.7426,
    y2: 1156.7947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M1260.1,1161.8c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L1260.1,1161.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1257.0305,
    y1: 1172.958,
    x2: 1586.2756,
    y2: 1172.958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M1257,1141.8c0,2,1.3,4,3.9,5.5l151.3,87.4c5.2,3,13.7,3,18.9,0l151.3-87.3 c2.6-1.5,3.9-3.5,3.9-5.5v-32.7c0,2-1.3,4-3.9,5.5l-151.3,87.3c-5.2,3-13.7,3-18.9,0l-151.3-87.4c-2.6-1.5-3.9-3.5-3.9-5.5V1141.8z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 1256.5637,
    y1: 1109.0999,
    x2: 1586.7426,
    y2: 1109.0999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M1260.1,1114.1c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L1260.1,1114.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1260.1,1091.6c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L1260.1,1091.6z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "#43FFBB",
    d: "M1586.3,1086.6c0-2-1.3-4-3.9-5.5l-151.3-87.4c-5.2-3-13.7-3-18.9,0l-151.3,87.3 c-2.6,1.5-3.9,3.5-3.9,5.5v-32.7c0-2,1.3-4,3.9-5.5l151.3-87.3c5.2-3,13.7-3,18.9,0l151.3,87.4c2.6,1.5,3.9,3.5,3.9,5.5V1086.6z"
  })), /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M184.7,1154.7c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10L354.9,1243c-4.8,2.8-12.6,2.8-17.3,0L184.7,1154.7z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "#43FFBB",
    d: "M510.8,1149.7c0-2-1.3-4-3.9-5.5l-151.3-87.4c-5.2-3-13.7-3-18.9,0l-151.3,87.3 c-2.6,1.5-3.9,3.5-3.9,5.5v-32.7c0-2,1.3-4,3.9-5.5l151.3-87.3c5.2-3,13.7-3,18.9,0l151.3,87.4c2.6,1.5,3.9,3.5,3.9,5.5V1149.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.6016,
    y1: 1277.9578,
    x2: 510.8467,
    y2: 1277.9578
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M181.6,1291c0,2,1.3,4,3.9,5.5l151.3,87.4c5.2,3,13.7,3,18.9,0l151.3-87.3 c2.6-1.5,3.9-3.5,3.9-5.5v-121.1c0,2-1.3,4-3.9,5.5l-151.3,87.3c-5.2,3-13.7,3-18.9,0l-151.3-87.4c-2.6-1.5-3.9-3.5-3.9-5.5V1291 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.1348,
    y1: 1169.8829,
    x2: 511.3137,
    y2: 1169.8829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M184.7,1174.9c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L184.7,1174.9z"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M380.4,1369.5v-78.4c0-1,0.5-1.9,1.3-2.3l24.1-13.9c1.3-0.8,3,0.2,3,1.7v76.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M419.4,1347v-111c0-1,0.5-1.9,1.3-2.3l24.1-13.9c1.3-0.8,3,0.2,3,1.7v109.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.6016,
    y1: 1181.2351,
    x2: 510.8467,
    y2: 1181.2351
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_23_)",
    d: "M181.6,1150c0,2,1.3,4,3.9,5.5l151.3,87.4c5.2,3,13.7,3,18.9,0l151.3-87.3 c2.6-1.5,3.9-3.5,3.9-5.5v-32.7c0,2-1.3,4-3.9,5.5l-151.3,87.3c-5.2,3-13.7,3-18.9,0l-151.3-87.4c-2.6-1.5-3.9-3.5-3.9-5.5V1150z "
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M184.7,1122.4c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L184.7,1122.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.5214,
    y1: 908.4293,
    x2: 1422.6973,
    y2: 908.4293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2765,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4539,
    style: {
      stopColor: "#11423F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#0E2A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M266.1,996.2l737.3-425.6c2.8-1.6,6.3-1.6,9.2,0l405.6,234.3c6.1,3.5,6.1,12.3,0,15.9 l-737.2,425.6c-2.8,1.6-6.3,1.6-9.2,0L266.1,1012C260,1008.5,260,999.7,266.1,996.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.6152,
    y1: 1034.2666,
    x2: 1422.6025,
    y2: 1034.2666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A0F14"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M261.6,1017.9c0.1,3.2,2.3,6.4,6.5,8.8l392.5,226.7c8.7,5,22.8,5,31.5,0l724-418 c4.4-2.6,6.6-5.9,6.5-9.3l0-14.5c0.2,3.5-1.9,7-6.5,9.6l-724,418c-8.7,5-22.8,5-31.5,0l-392.5-226.7c-4.3-2.5-6.5-5.8-6.5-9.1 L261.6,1017.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    points: "908.9,941.6 899.8,946.8 857.1,922.2 866.2,917  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1053.7,
    y1: 1031.3,
    x2: 629.7,
    y2: 786.5
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "857.1,941.6 866.2,946.8 908.9,922.2 899.8,917  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 504.7,
    y1: 1149.7,
    x2: 1193,
    y2: 752.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 531.6,
    y1: 971.7,
    x2: 1119.3,
    y2: 632.3
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 531.6,
    y1: 971.7,
    x2: 1119.3,
    y2: 632.3
  })), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 844.2,
    y1: 1152.3,
    x2: 458,
    y2: 929.4
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 1334.1,
    y1: 869.2,
    x2: 938.6,
    y2: 640.8
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 769.5,
    y1: 1195.4,
    x2: 346.2,
    y2: 950.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "740.9,1012.8 731.7,1007.6 689,1032.3 698.2,1037.5  "
  }), /*#__PURE__*/React.createElement("line", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#43FFBB",
    stroke: "#43FFBB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 291.2,
    y1: 1026.4,
    x2: 689,
    y2: 796.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "689,881 665.8,867.7 557.5,930.3 580.7,943.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.6,
    fill: "#43FFBB",
    points: "1001.7,700.8 1010.8,706 1053.5,681.4 1044.4,676.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1053.5,832.7 1076.7,845.9 1185.1,783.4 1161.9,770.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 1245.9934,
    y1: 321.6865,
    x2: 1349.6957,
    y2: 501.3041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "url(#SVGID_26_)",
    cx: 1297.8,
    cy: 411.5,
    r: 103.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1282.2859,
    y1: 300.7332,
    x2: 1398.9613,
    y2: 502.8211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "url(#SVGID_27_)",
    d: "M1419,323.2c-17.7,0-33.9,6-46.9,16c-18.8-19.4-45.2-31.4-74.3-31.4 c-57.3,0-103.7,46.4-103.7,103.7c0,57.3,46.4,103.7,103.7,103.7c13.9,0,27.1-2.7,39.2-7.7c7.8,4.8,17,7.5,26.9,7.5 c24,0,44.1-16.3,50-38.4c1.7,0.1,3.4,0.2,5.1,0.2c42.4,0,76.8-34.4,76.8-76.8C1495.8,357.6,1461.5,323.2,1419,323.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1381.1427,
    y1: 333.4879,
    x2: 1457.9559,
    y2: 466.5324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "url(#SVGID_28_)",
    cx: 1419.5,
    cy: 400,
    r: 76.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1338.6311,
    y1: 418.4222,
    x2: 1390.3988,
    y2: 508.0864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "url(#SVGID_29_)",
    cx: 1364.5,
    cy: 463.3,
    r: 51.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.4095,
    y1: 586.3589,
    x2: 322.1118,
    y2: 765.9765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "url(#SVGID_30_)",
    cx: 270.3,
    cy: 676.2,
    r: 103.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.702,
    y1: 565.4056,
    x2: 371.3774,
    y2: 767.4935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fill: "url(#SVGID_31_)",
    d: "M391.5,587.9c-17.7,0-33.9,6-46.9,16c-18.8-19.4-45.2-31.4-74.3-31.4 c-57.3,0-103.7,46.4-103.7,103.7c0,57.3,46.4,103.7,103.7,103.7c13.9,0,27.1-2.7,39.2-7.7c7.8,4.8,17,7.5,26.9,7.5 c24,0,44.1-16.3,50-38.4c1.7,0.1,3.4,0.2,5.1,0.2c42.4,0,76.8-34.4,76.8-76.8C468.3,622.3,433.9,587.9,391.5,587.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.5587,
    y1: 598.1603,
    x2: 430.372,
    y2: 731.2048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "url(#SVGID_32_)",
    cx: 392,
    cy: 664.7,
    r: 76.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.0472,
    y1: 683.0946,
    x2: 362.8149,
    y2: 772.7589
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2352,
    style: {
      stopColor: "#F4FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5708,
    style: {
      stopColor: "#E1FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#C2F8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFF8FF"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    fill: "url(#SVGID_33_)",
    cx: 336.9,
    cy: 727.9,
    r: 51.8
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M317.2,1171.6l-0.1-34.2l0-17.1c0-2.8-0.1-5.7,0.1-8.6c0.2-2.9,0.8-5.7,1.5-8.5c1.6-5.5,4.3-10.7,7.8-15.3 c3.6-4.5,8.1-8.3,13.1-11.1l29.5-17.2L487.2,991l59-34.4l29.5-17.2l7.4-4.3c2.4-1.4,5-2.9,7.7-4c5.4-2.2,11.3-3.4,17.2-3.4 c5.9,0,11.8,1.2,17.2,3.4c1.4,0.6,2.7,1.2,4,1.9l3.8,2.1l7.4,4.2l29.8,16.7l59.6,33.5l-1.7,0l403.1-231.8l50.5-28.8l6.3-3.6 l3.2-1.8c1.1-0.6,2.3-1.2,3.5-1.7c4.7-2.1,9.7-3.4,14.8-3.9c2.5-0.3,5.1-0.2,7.7-0.1c1.3,0.1,2.6,0.2,3.8,0.5l1.9,0.3l1.9,0.4 c1.3,0.3,2.5,0.7,3.7,1.1c1.2,0.5,2.4,0.9,3.6,1.4l1.7,0.8c0.6,0.3,1.1,0.6,1.7,0.9c1.2,0.6,2.2,1.3,3.2,1.9l49.1,31l6.1,3.9 c1,0.6,2,1.3,3.1,1.9c1.1,0.6,2.1,1.3,3.2,2.1c4.1,2.9,7.8,6.6,10.7,10.7c2.9,4.1,5.2,8.8,6.6,13.6c0.7,2.4,1.2,4.9,1.5,7.4 c0.2,1.3,0.3,2.5,0.3,3.8c0,0.6,0,1.3,0,1.9l0,1.8l-0.7,116.2l-0.1,14.5l0,7.3c0,2.4,0.1,4.7,0.4,7.1c1.3,9.4,5.8,18.3,12.7,24.9 c1.7,1.6,3.6,3.2,5.5,4.5c1.9,1.4,4.1,2.5,6.2,3.7l12.7,7.1l25.3,14.2l-0.2,0.4l-25.6-13.7l-12.8-6.9c-2.1-1.1-4.3-2.3-6.4-3.6 c-2.1-1.3-4-2.9-5.8-4.6c-7.2-6.7-12.2-15.9-13.7-25.7c-0.4-2.4-0.5-5-0.6-7.4l0-7.3l-0.1-14.5l-0.7-116.2l0-1.8 c0-0.6,0-1.2,0-1.7c-0.1-1.2-0.2-2.3-0.3-3.5c-0.3-2.3-0.8-4.6-1.5-6.8c-1.3-4.4-3.4-8.6-6.1-12.3c-2.7-3.7-6-7-9.8-9.6 c-1-0.7-1.9-1.3-2.9-1.9c-1-0.6-2.1-1.3-3.1-1.9l-6.2-3.8l-49.4-30.7c-1-0.6-2.1-1.3-3.1-1.8c-0.5-0.3-1-0.5-1.5-0.8l-1.6-0.7 c-1-0.5-2.1-0.8-3.2-1.2c-1.1-0.3-2.2-0.7-3.3-0.9c-4.4-1.1-9.1-1.4-13.6-1c-4.6,0.4-9,1.6-13.2,3.5c-1.1,0.5-2,1-3.1,1.5 l-3.2,1.8l-6.3,3.6l-50.4,28.9l-404,230.2l-0.8,0.5l-0.8-0.5l-59.4-33.7L639,941.9l-7.4-4.2l-3.7-2.1c-1.2-0.6-2.5-1.3-3.7-1.8 c-5.1-2.1-10.6-3.3-16.1-3.3c-5.5,0-11,1-16.1,3.1c-2.6,1-4.9,2.4-7.4,3.8l-7.4,4.3l-29.6,17l-59.2,34l-118.5,68.1l-29.6,17 c-4.9,2.7-9.3,6.4-12.8,10.8c-3.5,4.4-6.2,9.5-7.7,14.9c-0.8,2.7-1.3,5.5-1.6,8.3c-0.3,2.8-0.1,5.7-0.2,8.5l0,17.1l-0.1,34.2 H317.2z"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FBFBFB",
    cx: 1385.1,
    cy: 1005.9,
    r: 8.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1257.0305,
    y1: 1118.0983,
    x2: 1586.2756,
    y2: 1118.0983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_34_)",
    d: "M1257,1086.9c0,2,1.3,4,3.9,5.5l151.3,87.4c5.2,3,13.7,3,18.9,0l151.3-87.3 c2.6-1.5,3.9-3.5,3.9-5.5v-32.7c0,2-1.3,4-3.9,5.5l-151.3,87.3c-5.2,3-13.7,3-18.9,0l-151.3-87.4c-2.6-1.5-3.9-3.5-3.9-5.5V1086.9z "
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M1260.1,1059.2c-4.8-2.8-4.8-7.3,0-10L1413,961c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3c4.8,2.8,4.8,7.3,0,10 l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L1260.1,1059.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M1380.4,1144c-11.7,7.3-23.4,14.4-35.1,21.6l-17.6,10.7c-3,1.8-5.8,3.5-8.4,5.6 c-2.6,2.1-4.9,4.5-6.8,7.2c-3.9,5.3-6.6,11.5-7.8,17.9c-0.1,0.8-0.3,1.6-0.4,2.4l-0.2,2.4l-0.1,2.5c0,0.8,0,1.7,0,2.6l0.1,10.3 l0.3,41.2c0.3,55-0.2,110-0.5,164.9l-0.2,41.2c0,3.5,0.1,6.8-0.2,10.4c-0.3,3.6-1,7.1-2.1,10.5c-2.2,6.8-6.1,13-11.1,18.1 c-2.5,2.5-5.4,4.7-8.4,6.6c-3,1.8-6,3.5-8.9,5.2l-17.9,10.3l-35.7,20.6l-143,82.1l-0.3-0.4l142-83.9l35.5-20.9l17.8-10.5 c2.9-1.7,6-3.5,8.8-5.2c2.8-1.7,5.4-3.8,7.8-6.2c4.6-4.7,8.1-10.5,10.2-16.8c1-3.1,1.6-6.4,1.9-9.7c0.2-3.2,0.1-6.8,0.1-10.2 l-0.2-41.2c-0.3-55-0.8-110-0.5-164.9l0.3-41.2l0.1-10.3c0-0.9,0-1.7,0-2.6l0.1-2.7l0.3-2.7c0.1-0.9,0.3-1.8,0.4-2.7 c1.4-7.1,4.5-13.7,9-19.3c2.2-2.8,4.8-5.3,7.6-7.5c1.4-1.1,2.9-2.1,4.4-3c1.5-1,3-1.7,4.5-2.6l17.9-10.2c12-6.7,24-13.5,36-20.1 L1380.4,1144z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBFBFB",
    cx: 1378.7,
    cy: 1144.9,
    r: 8.2
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M1297.7,1095.1c-11.7,7.3-23.4,14.4-35.1,21.6l-17.6,10.7c-3,1.8-5.8,3.5-8.4,5.6 c-2.6,2.1-4.9,4.5-6.8,7.2c-3.9,5.3-6.6,11.5-7.8,17.9c-0.1,0.8-0.3,1.6-0.4,2.4l-0.2,2.4l-0.1,2.5c0,0.8,0,1.7,0,2.6l0.1,10.3 l0.3,41.2c0.3,55-0.2,110-0.5,164.9l-0.2,41.2c0,3.5,0.1,6.8-0.2,10.4c-0.3,3.6-1,7.1-2.1,10.5c-2.2,6.8-6.1,13-11.1,18.1 c-2.5,2.5-5.4,4.7-8.4,6.6c-3,1.8-6,3.5-8.9,5.2l-17.9,10.3l-35.7,20.6l-143,82.1l-0.3-0.4l142-83.9l35.5-20.9l17.8-10.5 c2.9-1.7,6-3.5,8.8-5.2c2.8-1.7,5.4-3.8,7.8-6.2c4.6-4.7,8.1-10.5,10.2-16.8c1-3.1,1.6-6.4,1.9-9.7c0.2-3.2,0.1-6.8,0.1-10.2 l-0.2-41.2c-0.3-55-0.8-110-0.5-164.9l0.3-41.2l0.1-10.3c0-0.9,0-1.7,0-2.6l0.1-2.7l0.3-2.7c0.1-0.9,0.3-1.8,0.4-2.7 c1.4-7.1,4.5-13.7,9-19.3c2.2-2.8,4.8-5.3,7.6-7.5c1.4-1.1,2.9-2.1,4.4-3c1.5-1,3-1.7,4.5-2.6l17.9-10.2c12-6.7,24-13.5,36-20.1 L1297.7,1095.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBFBFB",
    cx: 1295.9,
    cy: 1096,
    r: 8.2
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#43FFBB",
    d: "M1341,568.7l100.3,32.4c0.9,0.3,1,1.5,0.2,2l-76.8,46.4c-0.7,0.4-1.5,0-1.6-0.7l-6.3-35.1 l-14.4,4.9c-0.8,0.3-1.6-0.5-1.4-1.3l6.7-24.5l-8.1-22.5C1339.3,569.2,1340.1,568.4,1341,568.7z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#43FFBB",
    d: "M1347.8,592.6l93.5,8.5c0.7,0.1,1.2,1.4,0.2,2l-84.7,10.5l-14.4,4.9 c-0.8,0.3-1.6-0.5-1.4-1.3L1347.8,592.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#43FFBB",
    points: "1342.1,618.5 1357.8,619.3 1356.8,613.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.4666,
    y1: 724.6823,
    x2: 1092.0013,
    y2: 724.6823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_35_)",
    points: "773.5,705.4 838.6,742.7 1092,632.8 1092,705.4 838,816.6 773.5,779.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.4666,
    y1: 659.8763,
    x2: 1092.0013,
    y2: 659.8763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_36_)",
    points: "773.5,705.4 996.7,577.1 1092,632.8 838.6,742.7  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 772.9169,
    y1: 584.5909,
    x2: 1092.551,
    y2: 584.5909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M835.1,438.7l1-0.5l2.1,1.2c18.7,10.5,41.6,10.2,60.1-0.6l1.7-1l1.7,1 c63,48.3,105.7,11.1,124.3,0.1l1.3-0.8l1.2,0.7c19.1,11.1,42.7,11,61.7-0.4l2.4-1.4v184.3L836.1,732.2l-63.2-36.6V437.2l1.4,0.8 C793,449.2,816.2,449.4,835.1,438.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.5977,
    y1: 428.8451,
    x2: 1091.8701,
    y2: 428.8451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M773.6,438.1l9.3-0.6c22.3-1.6,43.9-8.9,62.5-21.2l11.1-7.3l0,0c28.8,9.3,48.5,3.9,68.9-9.9 l6.7-4.5l2.7,1.9c20.3,14.3,46.1,18,69.2,11.3c0,0,34.5,33.4,78.5,28.8l9.4,0.5c0,0-26.5,20.9-64.1,1.8c0,0-61,55.3-128.4-1 c0,0-28.7,20.9-63.9,0.4C835.4,438.3,806.4,457.9,773.6,438.1z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M976.8,517.4l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C975.5,518.7,976,517.9,976.8,517.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1000.5,616.4l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C999.2,617.8,999.7,616.9,1000.5,616.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1000.5,587.2l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C999.2,588.6,999.7,587.7,1000.5,587.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1000.5,555.3l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C999.2,556.6,999.7,555.8,1000.5,555.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M958.8,587.9l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3L960.4,598 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C957.4,589.3,957.9,588.4,958.8,587.9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M952.6,622.5l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C951.2,623.9,951.7,623,952.6,622.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1045.2,491.7l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C1043.8,493,1044.3,492.2,1045.2,491.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1046.3,549.8l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C1045,551.2,1045.5,550.3,1046.3,549.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1046.3,584.9l24.1-10.6c1.3-0.8,3,0.2,3,1.7v5.9c0,1-0.5,1.9-1.3,2.3l-24.1,10.6 c-1.3,0.8-2.9-0.2-2.9-1.7v-6C1045,586.3,1045.5,585.4,1046.3,584.9z"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FBFBFB",
    cx: 317.3,
    cy: 1170.8,
    r: 8.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FBFBFB",
    cx: 478,
    cy: 1284.5,
    r: 8.2
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M478.1,1285.3l131.5,74.8l65.7,37.5l1,0.6l1,0.5c0.6,0.4,1.3,0.6,2,0.9c1.4,0.5,2.8,0.9,4.2,1.2 c2.9,0.5,5.8,0.4,8.6-0.4c2.8-0.7,5.4-2,7.8-3.8c2.3-1.8,4.2-4,5.6-6.5c0.7-1.2,1.3-2.6,1.7-3.9c0.4-1.4,0.7-2.8,0.8-4.2 c0.1-0.7,0.1-1.4,0.1-2.2c0-0.9,0-1.7,0.1-2.6c0.1-1.7,0.5-3.4,1-5.1c2-6.6,6.9-12.3,13.2-15.3c3.1-1.5,6.5-2.4,10-2.6 c3.5-0.2,7,0.4,10.2,1.7c0.8,0.3,1.6,0.7,2.4,1.1l1.2,0.6l1,0.6l4.1,2.4l8.1,4.8c10.9,6.4,21.8,12.8,32.6,19.2l32.5,19.4 l32.4,19.5c21.6,13,43.2,26.1,64.7,39.3c21.5,13.1,43,26.3,64.4,39.7l-0.3,0.4c-22-12.4-43.9-24.9-65.7-37.5 c-21.9-12.6-43.7-25.2-65.5-37.9l-32.6-19.1l-32.6-19.2c-10.9-6.4-21.7-12.9-32.5-19.4l-8.1-4.8l-4.1-2.4l-1-0.6l-0.9-0.5 c-0.6-0.3-1.3-0.6-1.9-0.9c-5.2-2.2-11.3-2-16.5,0.5c-5.2,2.4-9.3,7-11,12.4c-0.4,1.4-0.7,2.8-0.9,4.2c-0.1,0.7-0.1,1.4-0.1,2.2 c0,0.9,0,1.7-0.2,2.6c-0.2,1.7-0.5,3.4-1.1,5c-0.5,1.6-1.2,3.2-2.1,4.7c-1.7,3-4,5.6-6.8,7.6c-2.8,2-5.9,3.5-9.2,4.3 c-3.3,0.8-6.8,0.9-10.2,0.3c-1.7-0.3-3.3-0.8-4.9-1.4c-0.8-0.3-1.6-0.7-2.3-1.1l-1.1-0.6l-1-0.6l-65.3-38.2l-130.4-76.7 L478.1,1285.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M924.1,1335.6c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L924.1,1335.6z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "#43FFBB",
    d: "M1250.3,1330.6c0-2-1.3-4-3.9-5.5l-151.3-87.4c-5.2-3-13.7-3-18.9,0l-151.3,87.3 c-2.6,1.5-3.9,3.5-3.9,5.5v-32.7c0-2,1.3-4,3.9-5.5l151.3-87.3c5.2-3,13.7-3,18.9,0l151.3,87.4c2.6,1.5,3.9,3.5,3.9,5.5V1330.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 921.0215,
    y1: 1513.4056,
    x2: 1250.2666,
    y2: 1513.4056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M921,1581c0,2,1.3,4,3.9,5.5l151.3,87.4c5.2,3,13.7,3,18.9,0l151.3-87.3c2.6-1.5,3.9-3.5,3.9-5.5 v-230.3c0,2-1.3,4-3.9,5.5l-151.3,87.3c-5.2,3-13.7,3-18.9,0l-151.3-87.4c-2.6-1.5-3.9-3.5-3.9-5.5V1581z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 920.5546,
    y1: 1350.7424,
    x2: 1250.7335,
    y2: 1350.7424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M924.1,1355.7c-4.8-2.8-4.8-7.3,0-10l152.9-88.3c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L924.1,1355.7z"
  })))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1160.1,1406l24.1-13.9c1.3-0.8,3,0.2,3,1.7v180.6c0,1-0.5,1.9-1.3,2.3l-24.1,13.9 c-1.3,0.8-2.9-0.2-2.9-1.7v-180.7C1158.8,1407.4,1159.3,1406.5,1160.1,1406z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M1210.3,1421.5l24.1-13.9c1.3-0.8,3,0.2,3,1.7v180.6c0,1-0.5,1.9-1.3,2.3l-24.1,13.9 c-1.3,0.8-2.9-0.2-2.9-1.7v-180.7C1208.9,1422.8,1209.4,1421.9,1210.3,1421.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 921.0215,
    y1: 1362.0946,
    x2: 1250.2666,
    y2: 1362.0946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_41_)",
    d: "M921,1330.9c0,2,1.3,4,3.9,5.5l151.3,87.4c5.2,3,13.7,3,18.9,0l151.3-87.3 c2.6-1.5,3.9-3.5,3.9-5.5v-32.7c0,2-1.3,4-3.9,5.5l-151.3,87.3c-5.2,3-13.7,3-18.9,0l-151.3-87.4c-2.6-1.5-3.9-3.5-3.9-5.5 V1330.9z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M924.1,1303.2c-4.8-2.8-4.8-7.3,0-10L1077,1205c4.8-2.8,12.6-2.7,17.3,0l152.8,88.3 c4.8,2.8,4.8,7.3,0,10l-152.9,88.3c-4.8,2.8-12.6,2.8-17.3,0L924.1,1303.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M679.5,859.6c-4.8-2.8-4.8-7.3,0-10l74.8-43.2c4.8-2.8,12.6-2.7,17.3,0l74.8,43.2c4.8,2.8,4.8,7.3,0,10 l-74.8,43.2c-4.8,2.8-12.6,2.8-17.3,0L679.5,859.6z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "#43FFBB",
    d: "M852.1,854.6c0-1.1-0.7-2.1-2.1-3l-81.9-47.3c-2.8-1.6-7.4-1.6-10.2,0l-81.9,47.3 c-1.4,0.8-2.1,1.9-2.1,3v-17.7c0-1.1,0.7-2.1,2.1-3l81.9-47.3c2.8-1.6,7.4-1.6,10.2,0L850,834c1.4,0.8,2.1,1.9,2.1,3V854.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.8334,
    y1: 959.5087,
    x2: 852.098,
    y2: 959.5087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M673.8,1002c0,1.1,0.7,2.1,2.1,3l81.9,47.3c2.8,1.6,7.4,1.6,10.2,0L850,1005 c1.4-0.8,2.1-1.9,2.1-3V865.5c0,1.1-0.7,2.1-2.1,3l-81.9,47.3c-2.8,1.6-7.4,1.6-10.2,0l-81.9-47.3c-1.4-0.8-2.1-1.9-2.1-3V1002z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.7626,
    y1: 865.5259,
    x2: 852.1691,
    y2: 865.5259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M675.2,863l86.3-49.8c0.9-0.5,2-0.5,2.9,0l86.3,49.8c2,1.1,2,4,0,5.1l-86.3,49.8 c-0.9,0.5-2,0.5-2.9,0l-86.3-49.8C673.3,866.9,673.3,864.1,675.2,863z"
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M787.9,939.8l13-7.5c0.7-0.4,1.6,0.1,1.6,0.9v97.8c0,0.5-0.3,1-0.7,1.3l-13.1,7.5 c-0.7,0.4-1.6-0.1-1.6-0.9v-97.8C787.2,940.6,787.4,940.1,787.9,939.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M822.3,884.5l13-7.5c0.7-0.4,1.6,0.1,1.6,0.9v97.8c0,0.5-0.3,1-0.7,1.3l-13.1,7.5 c-0.7,0.4-1.6-0.1-1.6-0.9v-97.8C821.6,885.2,821.8,884.8,822.3,884.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.8334,
    y1: 871.6724,
    x2: 852.098,
    y2: 871.6724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M673.8,854.8c0,1.1,0.7,2.1,2.1,3l81.9,47.3c2.8,1.6,7.4,1.6,10.2,0l81.9-47.3 c1.4-0.8,2.1-1.9,2.1-3v-17.7c0,1.1-0.7,2.1-2.1,3l-81.9,47.3c-2.8,1.6-7.4,1.6-10.2,0L675.9,840c-1.4-0.8-2.1-1.9-2.1-3V854.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.8123,
    y1: 837.0974,
    x2: 852.1194,
    y2: 837.0974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M675.3,834.5l86.2-49.8c0.9-0.5,2.1-0.5,3,0l86.2,49.8c2,1.1,2,4,0,5.2l-86.2,49.8 c-0.9,0.5-2.1,0.5-3,0l-86.2-49.8C673.3,838.5,673.3,835.7,675.3,834.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.8334,
    y1: 841.9005,
    x2: 852.098,
    y2: 841.9005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_46_)",
    d: "M673.8,825c0,1.1,0.7,2.1,2.1,3l81.9,47.3c2.8,1.6,7.4,1.6,10.2,0L850,828 c1.4-0.8,2.1-1.9,2.1-3v-17.7c0,1.1-0.7,2.1-2.1,3l-81.9,47.3c-2.8,1.6-7.4,1.6-10.2,0l-81.9-47.3c-1.4-0.8-2.1-1.9-2.1-3V825z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M675.4,804.7l86.1-49.7c0.9-0.5,2.1-0.5,3,0l86.1,49.7c2,1.2,2,4.1,0,5.3l-86.1,49.7 c-0.9,0.5-2.1,0.5-3,0l-86.1-49.7C673.4,808.8,673.4,805.9,675.4,804.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.8334,
    y1: 810.4932,
    x2: 852.098,
    y2: 810.4932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fill: "url(#SVGID_47_)",
    d: "M673.8,793.6c0,1.1,0.7,2.1,2.1,3l81.9,47.3c2.8,1.6,7.4,1.6,10.2,0l81.9-47.3 c1.4-0.8,2.1-1.9,2.1-3v-17.7c0,1.1-0.7,2.1-2.1,3l-81.9,47.3c-2.8,1.6-7.4,1.6-10.2,0l-81.9-47.3c-1.4-0.8-2.1-1.9-2.1-3V793.6z "
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#43FFBB",
    d: "M675.2,773.4l86.4-49.9c0.9-0.5,2-0.5,2.9,0l86.3,49.9c1.9,1.1,1.9,3.9,0,5l-86.3,49.9 c-0.9,0.5-2,0.5-2.9,0l-86.3-49.9C673.2,777.3,673.2,774.5,675.2,773.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 667.9516,
    y1: 1390.7771,
    x2: 772.6823,
    y2: 1390.7771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M772.7,1594L772.7,1594c-26,19-78.1,20-104.2,1.4l-0.5-0.3l9.8-221.2v-201.1h85.1v201.5 L772.7,1594z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.7819,
    y1: 5161.0044,
    x2: 783.8521,
    y2: 5161.0044,
    gradientTransform: "matrix(1 0 0 -1 0 6445.5269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_49_)",
    d: "M656.8,1279.5c0-11.5,28.4-20.8,63.5-20.8c35.1,0,63.5,9.3,63.5,20.8v31 c0-11.5-28.4-20.8-63.5-20.8c-35.1,0-63.5,9.3-63.5,20.8V1279.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.9935,
    y1: 1503.0992,
    x2: 777.6403,
    y2: 1503.0992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_50_)",
    cx: 720.3,
    cy: 1503.1,
    rx: 57.3,
    ry: 20.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.9935,
    y1: 1516.6588,
    x2: 777.6403,
    y2: 1516.6588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M663,1510.1c0,11.1,25.7,20.2,57.3,20.2c31.7,0,57.3-9,57.3-20.2v-7c0,11.1-25.7,20.2-57.3,20.2 c-31.7,0-57.3-9-57.3-20.2V1510.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 671.9516,
    y1: 1430.0593,
    x2: 768.7396,
    y2: 1430.0593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M762.9,1345.7v28.6l5.9,131.2h0c-30.8,13.9-66,13.9-96.8,0l0,0l5.8-131.6v-29.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 650.4453,
    y1: 1312.2241,
    x2: 790.1887,
    y2: 1312.2241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_53_)",
    cx: 720.3,
    cy: 1312.2,
    rx: 69.9,
    ry: 24.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 650.4453,
    y1: 1331.4812,
    x2: 790.1887,
    y2: 1331.4812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M650.4,1326.2c0,13.6,31.3,24.6,69.9,24.6c38.6,0,69.9-11,69.9-24.6v-13.9 c0,13.6-31.3,24.6-69.9,24.6c-38.6,0-69.9-11-69.9-24.6V1326.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 677.7775,
    y1: 1263.1697,
    x2: 762.8563,
    y2: 1263.1697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M762.9,1311.7L762.9,1311.7c-26.5,14.9-57.6,15.3-84.6,0.3l-0.5-0.3v-108.5h0 c26.7,13.7,58.4,13.7,85.1,0v21.8V1311.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 650.4453,
    y1: 1184.8691,
    x2: 790.1887,
    y2: 1184.8691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_56_)",
    cx: 720.3,
    cy: 1184.9,
    rx: 69.9,
    ry: 24.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 650.4453,
    y1: 1204.1263,
    x2: 790.1887,
    y2: 1204.1263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M650.4,1198.8c0,13.6,31.3,24.6,69.9,24.6c38.6,0,69.9-11,69.9-24.6v-13.9 c0,13.6-31.3,24.6-69.9,24.6c-38.6,0-69.9-11-69.9-24.6V1198.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.7819,
    y1: 5289.3027,
    x2: 783.8521,
    y2: 5289.3027,
    gradientTransform: "matrix(1 0 0 -1 0 6445.5269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_58_)",
    d: "M656.8,1151.2c0-11.5,28.4-20.8,63.5-20.8c35.1,0,63.5,9.3,63.5,20.8v31 c0-11.5-28.4-20.8-63.5-20.8c-35.1,0-63.5,9.3-63.5,20.8V1151.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.7819,
    y1: 1179.6534,
    x2: 783.8521,
    y2: 1179.6534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_59_)",
    d: "M656.8,1184.7c0,11.5,28.4,20.8,63.5,20.8c35.1,0,63.5-9.3,63.5-20.8v-31 c0,11.5-28.4,20.8-63.5,20.8c-35.1,0-63.5-9.3-63.5-20.8V1184.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 685.0613,
    y1: 1102.6532,
    x2: 755.6299,
    y2: 1102.6532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M685.1,1116.1c0-19.5,15.8-35.4,35.3-35.4c19.5,0,35.1,15.8,35.3,35.3c0,0-11.3,8.6-35.3,8.6 C699.4,1124.6,685.1,1116.1,685.1,1116.1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 685.0613,
    y1: 1157.3003,
    x2: 755.6008,
    y2: 1157.3003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_61_)",
    d: "M755.6,1187.9L755.6,1187.9c-22,14-48.1,14.1-70.1,0.3l-0.4-0.3v-71.8l0,0 c22.1,11.4,48.4,11.4,70.5,0v18.1V1187.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.7819,
    y1: 1307.9515,
    x2: 783.8521,
    y2: 1307.9515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "url(#SVGID_62_)",
    d: "M656.8,1313c0,11.5,28.4,20.8,63.5,20.8c35.1,0,63.5-9.3,63.5-20.8v-31 c0,11.5-28.4,20.8-63.5,20.8c-35.1,0-63.5-9.3-63.5-20.8V1313z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M750.3,1470.5l8.1-4.7c0.2-0.1,0.4,0,0.4,0.3v15.9c0,0.1-0.1,0.3-0.2,0.3l-8.1,4.7 c-0.2,0.1-0.4,0-0.4-0.3v-15.9C750.1,1470.7,750.2,1470.6,750.3,1470.5z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M754.7,1551l8.1-4.7c0.2-0.1,0.4,0,0.4,0.3v15.9c0,0.1-0.1,0.3-0.2,0.3l-8.1,4.7 c-0.2,0.1-0.4,0-0.4-0.3v-15.9C754.5,1551.2,754.6,1551.1,754.7,1551z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M750.3,1283.8l8.1-4.7c0.2-0.1,0.4,0,0.4,0.3v15.9c0,0.1-0.1,0.3-0.2,0.3l-8.1,4.7 c-0.2,0.1-0.4,0-0.4-0.3v-15.9C750.1,1284,750.2,1283.9,750.3,1283.8z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M750.3,1258.9l8.1-4.7c0.2-0.1,0.4,0,0.4,0.3v15.9c0,0.1-0.1,0.3-0.2,0.3l-8.1,4.7 c-0.2,0.1-0.4,0-0.4-0.3v-15.9C750.1,1259.1,750.2,1259,750.3,1258.9z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#43FFBB",
    d: "M750.3,1234.4l8.1-4.7c0.2-0.1,0.4,0,0.4,0.3v15.9c0,0.1-0.1,0.3-0.2,0.3l-8.1,4.7 c-0.2,0.1-0.4,0-0.4-0.3v-15.9C750.1,1234.6,750.2,1234.5,750.3,1234.4z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43FFBB",
    strokeMiterlimit: 10,
    d: "M720.4,1080.7c11.1,7.5,16.1,22.7,16.1,42.2v73.5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43FFBB",
    strokeMiterlimit: 10,
    d: "M720.4,1080.7c16.1,3.9,27.9,18.8,27.9,38.3v73.5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43FFBB",
    strokeMiterlimit: 10,
    d: "M720.4,1080.7c-16.1,3.9-27.9,18.8-27.9,38.3v73.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 710.6694,
    y1: 1077.5186,
    x2: 730.0217,
    y2: 1077.5186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1266,
    style: {
      stopColor: "#41F8B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#3BE5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "#31C694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7573,
    style: {
      stopColor: "#239A77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#136654"
    }
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_63_)",
    cx: 720.3,
    cy: 1077.5,
    r: 9.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 603.7036,
    y1: 1193.2189,
    x2: 720.3113,
    y2: 1193.2189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696",
      stopOpacity: 0.7756
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D",
      stopOpacity: 0.503
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53",
      stopOpacity: 0.3035
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049",
      stopOpacity: 0.2
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    fill: "url(#SVGID_64_)",
    points: "720.3,1147.9 603.7,1216.3 642.4,1238.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 8002.3652,
    y1: 4806.8882,
    x2: 8118.9727,
    y2: 4806.8882,
    gradientTransform: "matrix(-1 0 0 -1 8839.4043 5909.436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002229595,
    style: {
      stopColor: "#43FFBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#33C696",
      stopOpacity: 0.7756
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6221,
    style: {
      stopColor: "#22876D",
      stopOpacity: 0.503
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8709,
    style: {
      stopColor: "#175F53",
      stopOpacity: 0.3035
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#135049",
      stopOpacity: 0.2
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    fill: "url(#SVGID_65_)",
    points: "720.4,1147.9 837,1079.5 798.4,1057.2  "
  }))))));
}

export default SvgIlluCity;